/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
import type { StatePropsOfMasterItem } from '@jsonforms/core';
import { withJsonFormsMasterListItemProps } from '@jsonforms/react';
import {
  Avatar,
  IconButton,
  ListItemButton,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Tooltip,
} from '@mui/material';
import { Delete } from '@mui/icons-material';
import React from 'react';

export const ListWithDetailMasterItem = ({
  index,
  childLabel,
  selected,
  enabled,
  handleSelect,
  removeItem,
  path,
  translations,
  disableRemove,
}: StatePropsOfMasterItem) => {
  return (
    <ListItemButton selected={selected} onClick={handleSelect(index)}>
      <ListItemAvatar>
        <Avatar aria-label='Index'>{index + 1}</Avatar>
      </ListItemAvatar>
      <ListItemText primary={childLabel} />
      {enabled && !disableRemove && (
        <ListItemSecondaryAction>
          <Tooltip
            id='tooltip-remove'
            title={translations.removeTooltip}
            placement='bottom'
          >
            <IconButton
              aria-label={translations.removeAriaLabel}
              onClick={removeItem(path, index)}
              size='large'
            >
              <Delete />
            </IconButton>
          </Tooltip>
        </ListItemSecondaryAction>
      )}
    </ListItemButton>
  );
};

export default withJsonFormsMasterListItemProps(ListWithDetailMasterItem);
